import {Route, Redirect} from "react-router-dom";
import React from "react";
import {isLogin, notificationAlert} from "../helpers/common";

export const RouteIf = ({option, component: Component, ...rest}) => {
    return (
        <Route
            {...rest}
            render={props => {
                // 권한 체크
                const isAuth = isLogin();
                //로그인을 하지 않았을때
                if (option == null && Component) {
                    return <Component {...props}  />;
                }
                if (!isAuth) {
                    //옵션이 true일때 로그인으로 강제 이동
                    if (option) {
                        notificationAlert('오류','로그인 후 이용가능한 서비스 입니다.');
                        return <Redirect
                            to={{
                                pathname: "/",
                                state: {from: props.location}
                            }}
                        />

                    }
                } else {
                    if (!option) {
                        // window.location.href = '/login';
                        notificationAlert('오류','이미 로그인 되어 있습니다.');
                        return <Redirect
                            to={{
                                pathname: "/",
                                state: {from: props.location}
                            }}
                        />
                    }
                }
                if (Component) {
                    // role을 컴포넌트에 전달
                    return <Component {...props}  />
                }

                return null
            }}
        />
    )
}
